import { IClientConfig } from "src/client-config/config";
import { IBonusRule, ICurrencyConfig, IPartnerConfig } from "src/constants/interfaces";
import { ISelection } from "src/constants/interfaces/bet";
import { getBetCalculations } from 'calculation';
import { BetTypeEnum } from "src/constants/enums/betType";
import { BetCalculationsEnum } from "src/constants/enums/betCalculations";
import { TaxTypeEnum } from "src/constants/enums/tax";
import { roundAmount } from "../helpers";

export const getTaxedStake = (
    partnerConfig: IPartnerConfig | undefined,
    stake: number,
    currencyConfig?: ICurrencyConfig
) => {
    const taxPercent = partnerConfig?.tax_percent;
    return +roundAmount(taxPercent ? stake / 100 * (100 - taxPercent) : stake, currencyConfig);
};

export const getTaxForReturnedOrProfit = (config: IClientConfig, stake: number, events: ISelection[], betType: BetTypeEnum, partnerConfig?: IPartnerConfig, currencyConfig?: ICurrencyConfig, bonusRule?: IBonusRule[]) => {
    let result = 0;

    if (!bonusRule || !partnerConfig) return result

    const taxRange = partnerConfig.tax_amount_ranges || config.taxRange
    const taxType = partnerConfig.tax_amount_ranges?.[0]?.type || partnerConfig.tax_type

    const {
        taxedStake,
        possibleWin,
        expressBonus
    } = getBetCalculations([
        BetCalculationsEnum.TaxOnStake,
        BetCalculationsEnum.PossibleWin,
        BetCalculationsEnum.Bonus
        ], {
            config,
            partnerConfig,
            stake,
            events,
            betType,
            bonusRule,
            currencyConfig,
        })

    const amount = (taxType === TaxTypeEnum.Return ? possibleWin : possibleWin - taxedStake) + (expressBonus.amount || 0)

    if (taxRange) {
        for (const item of taxRange) {
            const { from, to, entire_amount, percent } = item;

            if (entire_amount) {
                if (from <= amount && to > amount) {
                    result = amount * percent / 100;
                    break;
                }
            } else if (from < amount && percent > 0 && percent < 100)
            {
                if (amount <= to) {
                    result += (amount - from) * percent / 100;
                    break;
                } else {
                    result += (to - from) * percent / 100;
                }
            }
        }
    }

    return result;
}
